import type { FlowCanvasPhase } from '../../store/storeFlows';

export const POST_READY_NON_CRITICAL_PATCH_MAX_WAIT_MS = 3500;

export function canUnlockNonCriticalPatch(
  nowMs: number,
  phase: FlowCanvasPhase,
  readyAtMs: number,
  userGestureUnlock: boolean,
): boolean {
  if (phase !== 'ready') {
    return false;
  }
  if (userGestureUnlock) {
    return true;
  }
  if (!readyAtMs) {
    return true;
  }
  return nowMs - readyAtMs >= POST_READY_NON_CRITICAL_PATCH_MAX_WAIT_MS;
}
